// extracted by mini-css-extract-plugin
export var addressFields = "_lq-0";
export var animationContainer = "_lq-1";
export var footer = "_lq-2";
export var lineItems = "_lq-3";
export var modalContent = "_lq-4";
export var orderName = "_lq-5";
export var strong = "_lq-6";
export var warning = "_lq-7";